import { cn } from '@lyearn/style';
import { BaseIconButton, Box, usePopoverContext } from '@lyearn/ui';
import { activeBgColor, hoverBgColor } from '@/components/IconPicker/styles';
import { bgColor, borderColor } from '@/utils/styles';

import {
  IconSettingsColorPickerColorListItemProps,
  IconSettingsColorPickerColorListProps,
} from './types';

const IconSettingsColorPickerColorListItem = (props: IconSettingsColorPickerColorListItemProps) => {
  const { config, isSelected, value, onChange } = props;
  const { onClose } = usePopoverContext();

  return (
    <BaseIconButton
      className={
        isSelected
          ? cn('border-2 border-solid p-2 hover:bg-transparent', borderColor(value))
          : cn('p-[0.5rem]', hoverBgColor(config.color.hover), activeBgColor(config.color.active))
      }
      onClick={() => {
        onChange(value);
        onClose();
      }}>
      <Box className={cn('h-22 w-22 rounded-full', bgColor(value))} />
    </BaseIconButton>
  );
};

const IconSettingsColorPickerColorList = (props: IconSettingsColorPickerColorListProps) => {
  const { colorConfig, value, onChange } = props;

  return (
    <Box className="grid grid-cols-5 gap-x-4 px-16 py-0">
      {Object.entries(colorConfig).map(([color, config]) => (
        <IconSettingsColorPickerColorListItem
          key={color}
          config={config}
          isSelected={value?.iconColor === color}
          value={color}
          onChange={onChange}
        />
      ))}
    </Box>
  );
};

export default IconSettingsColorPickerColorList;
